<template>
    <div v-if="data" class="company-info__main">
      <div class="company-info__wrap">
        <div class="company-info__group">
            <div class="company-info__title">{{$tEmployer('Register data')}}</div>
            <div @click="$emit('change-data')" class="inline-link change-data-link d-sm-none">
                <BaseSvg name="ico-edit" class="ico-edit" height="1.4rem" width="1.3rem" />
                <span>{{$tEmployer('Apply for data change')}}</span>
            </div>

            <div class="company-info__inner">
                <div class="company-info__input-row">
                    <BaseInput v-model="data.inputs.nameCompany.value"
                               :required="data.inputs.nameCompany.required"
                               :error="data.inputs.nameCompany.error"
                               :label="this.$tEmployer('Company name')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.shortNameCompany.value"
                               :required="data.inputs.shortNameCompany.required"
                               :error="data.inputs.shortNameCompany.error"
                               :label="this.$tEmployer('Company short name')"
                               maxLength="27"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.codeCompany.value"
                               :required="data.inputs.codeCompany.required"
                               :error="data.inputs.codeCompany.error"
                               :label="this.$tEmployer('Company code')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                </div>
            </div>
        </div>
        <div class="company-info__group">
            <div class="company-info__title">{{$tAddress('Address')}}</div>
            <div class="company-info__inner">
                <div class="company-info__input-row">
                    <BaseInput v-model="data.inputs.country.value"
                               :required="data.inputs.country.required"
                               :error="data.inputs.country.error"
                               :label="this.$tAddress('Country')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.region.value"
                               :required="data.inputs.region.required"
                               :error="data.inputs.region.error"
                               :label="this.$tAddress('Region')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.locality.value"
                               :required="data.inputs.locality.required"
                               :error="data.inputs.locality.error"
                               :label="this.$tAddress('Locality')"
                               class="company-info__input"
                               @index="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.district.value"
                               :required="data.inputs.district.required"
                               :label="this.$tAddress('District')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                </div>
                <div class="company-info__input-row">
                    <BaseInput v-model="data.inputs.street.value"
                               :required="data.inputs.street.required"
                               :error="data.inputs.street.error"
                               :label="this.$tAddress('Street')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.house.value"
                               :required="data.inputs.house.required"
                               :error="data.inputs.house.error"
                               :label="this.$tAddress('House')"
                               class="company-info__input"
                               @index="$emit('change')"
                    />
                    <BaseInput  v-model="data.inputs.office.value"
                                :required="data.inputs.office.required"
                                :error="data.inputs.office.error"
                                :label="this.$tAddress('Office')"
                                class="company-info__input"
                                @input="$emit('change')"
                    />
                    <BaseInput v-model="data.inputs.indexCompany.value"
                               :required="data.inputs.indexCompany.required"
                               :error="data.inputs.indexCompany.error"
                               :label="this.$tAddress('Index')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />
                </div>
            </div>
        </div>
        <div class="company-info__group">
            <div class="company-info__title">{{$tEmployer('Contacts')}}</div>
            <div class="company-info__inner">
                <div class="company-info__input-row">
                    <BaseInput v-model="data.inputs.agentCompany.value"
                               :required="data.inputs.agentCompany.required"
                               :error="data.inputs.agentCompany.error"
                               :label="this.$tEmployer('Company representative')"
                               class="company-info__input"
                               @input="$emit('change')"
                    />

                  <BaseInputPhone v-model="data.inputs.phone.value"
                                  :value="data.inputs.phone.value"
                                  :label="$tProfile('Phone')"
                                  :required="data.inputs.phone.required"
                                  :error="$tAuth(data.inputs.phone.error)"
                                  class="company-info__input"
                                  @input="$emit('change')"
                                  white
                  />
                    <BaseInput v-model="data.inputs.website.value"
                               :required="data.inputs.website.required"
                               :label="this.$tEmployer('Website')"
                               @input="$emit('change')"
                               class="company-info__input"
                    />
                    <BaseInput type="email"
                               v-model="data.inputs.email.value"
                               :required="data.inputs.email.required"
                               :error="data.inputs.email.error"
                               :label="this.$tEmployer('Email')"
                               @input="$emit('change')"
                               class="company-info__input"
                    />
                </div>
            </div>
        </div>
      </div>
     <!-- <div class="company-info__button-row">
        <button class=" base-btn  base-btn&#45;&#45;blue">
          <span>{{$tEmployer('I want to post vacancies')}}</span>
        </button>
        <BaseHelp value="Some text by props value"
                  width="30rem"
                  class="company-info__button-row-help"/>
      </div>-->
    </div>
</template>

<script>
    import employerFormFields from '../mixins/employerFormFields';

    export default {
        name: "RegistrationInfo",
        mixins: [ employerFormFields ],
        data() {
            return {
                translateFiledEditor: null
            }
        }
    }
</script>

<style scoped>

</style>
